export const uamAssetsMapping = (data, isHolder) => data.map((asset) => uamDeviceInfoMapping(asset, isHolder));

const uamDeviceInfoMapping = (data, isHolder) => ({
    assetId: data.assetId,
    serialNumber: data?.device?.serialNumber,
    material: data?.material,
    isHolder: !!isHolder,
    configurationCode: data?.device?.configurationCode,
    sblMajorVersion: data.device?.sblMajorVersion,
    associatedDevices: data.device?.associatedDevices,
});
